var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOvhIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.18 47.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000e9c;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.14,2.69A40.1,40.1,0,0,1,69.4,47.18H48l6.6-11.67H45.83L56.12,17.38H64.9L73.14,2.71ZM30.8,47.18H8.94A39.59,39.59,0,0,1,5.15,2.59L19.33,27.22,35,0H58L30.81,47.16h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvhIconNew);
export default __webpack_public_path__ + "static/media/OVH-icon-new.d4a89662d4e0032a01cf437a1e5e7dec.svg";
export { ForwardRef as ReactComponent };